module.exports = __webpack_public_path__ + "img/hppc_dark_logo.ced3de6f.png";